import React from 'react';

export const ADVIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g
                fill="none"
                fillOpacity="1"
                stroke="#fff"
                strokeDasharray="none"
                strokeMiterlimit="4"
                strokeOpacity="1"
                strokeWidth="0.529"
            >
                <rect
                    width="5.292"
                    height="4.762"
                    x="0.265"
                    y="0.529"
                    rx="1.058"
                    ry="1.058"
                ></rect>
                <rect
                    width="3.704"
                    height="1.058"
                    x="1.058"
                    y="3.44"
                    rx="0.265"
                    ry="0.265"
                ></rect>
            </g>
        </svg>
    );
};
